import { MeOfficialPlan } from '../../models/auth/new-me.model';

export const MINIMUM_PLAN_SLUG = 'ratoeira-ads-minimum';

export function isMinimumOfficialPlan(plan: MeOfficialPlan | null | undefined): boolean {
    return plan?.productSlug === MINIMUM_PLAN_SLUG;
}
